import { render, staticRenderFns } from "./RunnitSettingHelperBtn.vue?vue&type=template&id=5b6a2636&scoped=true"
import script from "./RunnitSettingHelperBtn.vue?vue&type=script&lang=ts"
export * from "./RunnitSettingHelperBtn.vue?vue&type=script&lang=ts"
import style0 from "./RunnitSettingHelperBtn.vue?vue&type=style&index=0&id=5b6a2636&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a2636",
  null
  
)

export default component.exports